"use strict";
class ContactUsController {
    constructor($parse, $scope, SSHttpService, SSUtilService, SSUserService, SSAlertService) {

        const self = this;

        self.$parse = $parse;

        self.$scope = $scope;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;

        self.data = SHOWSUITE.data;
        self.maskPhoneNumber(self, 'ctrl.', 'contactUsModal');
        self.SSUserService.feedbackParams = {
            type: 10,
            data: {
                salutation: 'mr'
            }
        };
    }

    submitContactUs() {
        const self = this;

        if (self.validateContactUsParams()) return;
        
        //Validate google captcha
        var googleResponse = $('#captcha').val();
        if (!googleResponse) {
            self.showCaptchaError = true;
            return;
        }

        let params = angular.copy(self.SSUserService.feedbackParams);

        if (params.data) {
            params.data = JSON.stringify(params.data);
        }

        self.SSUserService.feedbackErrors = {};
        
        loading(true);
        self.SSHttpService.postAPIRequest('feedback', params).then(
            function (response) {
                loading(false);

                if (response instanceof Error) {
                    self.SSAlertService.parseAndDisplayError(response);

                    // Form Errors
                    self.SSUserService.feedbackErrors = {};
                    jQuery.each(response.data, function (key, value) {
                        try {
                            self.SSUserService.feedbackErrors[key] = value[0];
                        } catch (ex) {
                        }
                    });
                    // Form Errors

                    return;
                }

                self.contact_us_success = true;
            }
        );
    }

    validateContactUsParams() {
        const self = this;

        let hasError = false;
        self.SSUserService.feedbackErrors = {};

        if (!self.SSUserService.feedbackParams.first_name) {
            self.SSUserService.feedbackErrors.first_name = "The First Name field is required.";
            hasError = true;
        }
        if (!self.SSUserService.feedbackParams.last_name) {
            self.SSUserService.feedbackErrors.last_name = "The Last Name field is required.";
            hasError = true;
        }
        if (!self.SSUserService.feedbackParams.email) {
            self.SSUserService.feedbackErrors.email = "The Email field is required.";
            hasError = true;
        }

        if (!self.SSUserService.feedbackParams.message) {
            self.SSUserService.feedbackErrors.message = "The Message field is required.";
            hasError = true;
        }

        if (jQuery('.intl-tel-input').hasClass('has-error') && jQuery("[allowdropdown='']").val() != '') {
            self.SSUserService.feedbackErrors.phone1 = "The Phone format is not valid.";
            hasError = true;
        }

        return hasError;
    }

    checkURL(event) {
        var url_input = event.target;

        var string = url_input.value;
        if (!string.match(/^https?:/)) {
            string = "http://" + string;
        }
        url_input.value = string;
    }

    maskPhoneNumber(context, contextPrefix, formId) {
        let self = this;

        let parent = jQuery;
        if (formId) {
            parent = jQuery('#' + formId);
        }

        jQuery.each(parent.find('input[type=tel]'), function (i, el) {
            let field = jQuery(el);

            let allowDropdown = field.attr('allowDropdown');
            allowDropdown = !allowDropdown || allowDropdown !== 'false';

            field.intlTelInput({
                initialCountry: 'sg',
                geoIpLookup: self.SSUtilService.geoIpLookup,
                allowDropdown: allowDropdown,
                preferredCountries: ['sg']
            });

            let model = field.attr('ng-model');
            if (model) {
                if (startsWith(model, contextPrefix)) {
                    model = model.substring(contextPrefix.length);
                }
                let value = self.$parse(model)(context);
                if (value) {
                    field.intlTelInput('setNumber', value);
                }
            }

            field.on("keyup change", function () {

                field.parent().removeClass("has-error");
            });
            field.blur(function () {
                var currentFormat = (field.val() && field.val()[0] === "+") ? intlTelInputUtils.numberFormat.INTERNATIONAL : intlTelInputUtils.numberFormat.NATIONAL;
                field.val(field.intlTelInput("getNumber", currentFormat));
                field.parent().removeClass("has-error");
                if (!field.intlTelInput("isValidNumber")) {
                    field.parent().addClass("has-error");
                    if (model) {
                        //self.$parse(model).assign(context, ""); // Don't remove the number if invalid, unless we upgrade to version of latest intl-tel-input
                    }
                } else {
                    if (model) {
                        self.$parse(model).assign(context, field.intlTelInput("getNumber"));
                    }
                }
            });
        });
    }

}

ContactUsController.$inject = ['$parse', '$scope', 'SSHttpService', 'SSUtilService', 'SSUserService', 'SSAlertService'];
app.controller('ContactUsController', ContactUsController);

